import { Checkbox, FormControlLabel, Typography, SxProps, Box } from '@mui/material';
import { FC } from 'react';
import { BookRefinementListProps } from '@models/books';

type FormSx = (filterCount: number) => SxProps;

const formSx: FormSx = (filterCount: number) => ({
    '& .MuiFormControlLabel-root:not(:last-child) .MuiTypography-root': {
        border: 1,
        borderBottom: 0,
        borderColor: 'grey.500',
        borderLeft: 0,
        borderTop: 0,
    },
    border: 1,
    borderColor: 'grey.500',
    borderRadius: 0.5,
    display: 'grid',
    gridTemplateColumns: `repeat(${filterCount}, minmax(auto, 1fr))`,
    overflow: 'hidden',
});

const hiddenInputSx: SxProps = {
    '& svg': {
        height: 'inherit',
        width: 'inherit',
    },
    height: 0,
    pointerEvents: 'none',
    position: 'absolute',
    width: 0,
    zIndex: -1,
};

type LabelSx = (selected: boolean) => SxProps;

const labelSx: LabelSx = (selected: boolean) => ({
    bgcolor: 'common.white',
    fontSize: 14,
    lineHeight: 2,
    py: 0.5,
    textAlign: 'center',
    width: '100%',
    ...(selected && {
        bgcolor: 'grey.400',
        color: 'grey.900',
    }),
});

const titleSx: SxProps = {
    color: 'grey.300',
    mb: 1,
    typography: 'body2',
};

const BookRefinementList: FC<BookRefinementListProps> = ({
    items,
    listTitle,
    multiple,
    selected,
    setSelected,
}) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { value, checked } = event.target;
        if (multiple) {
            setSelected(checked ? [...selected, value] : selected.filter((v) => v !== value));
        } else {
            setSelected(checked ? [value] : []);
        }
    };

    return (
        <Box>
            <Typography sx={titleSx}>{listTitle}</Typography>
            <Box sx={formSx(items.length)}>
                {items.map(({ label, value }) => (
                    <FormControlLabel
                        key={`book-filter-${value}`}
                        control={
                            <Checkbox
                                checked={selected.includes(value)}
                                color="primary"
                                onChange={handleChange}
                                sx={hiddenInputSx}
                                value={value}
                            />
                        }
                        label={
                            <Typography sx={labelSx(selected.includes(value))}>{label}</Typography>
                        }
                        sx={{ m: 0 }}
                    />
                ))}
            </Box>
        </Box>
    );
};

export default BookRefinementList;
